import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CompanyState = {
  data: [],
  isLoading: false,
  error: null,
};

const companySlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    setCompanies: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCompanyLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setCompanyError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setCompanies, setCompanyLoading, setCompanyError } = companySlice.actions;

export default companySlice.reducer;
